/**
 * §P.11 · El marco de «Material».
 *
 * Cuatro pantallas y un solo trabajo, el de septiembre: publicar lo que vendes,
 * recoger lo que pide cada familia, cursarlo y entregarlo. El tablón de segunda mano
 * va aquí y no aparte porque es la misma pregunta —de dónde sale el dobok— contestada
 * por otra vía.
 *
 * El guardián está aquí y no en cada pantalla, igual que en `MarcoDeCobros`: con rutas
 * de verdad, `/material/solicitudes` se puede escribir en la barra.
 */
import { Link, Navigate, Outlet, useRouterState } from '@tanstack/react-router';
import { VISTAS_DE_MATERIAL } from '@/club/secciones';
import { useContextoDelClub } from '@/club/contexto';
import { puedeVerMaterial } from '@/club/permisos';

export function MarcoDeMaterial() {
  const camino = useRouterState({ select: (s) => s.location.pathname });
  const { rol } = useContextoDelClub();

  if (!puedeVerMaterial(rol)) return <Navigate to="/alumnos" replace />;

  return (
    <>
      <nav className="pestañas" aria-label="Pantallas de material">
        {VISTAS_DE_MATERIAL.map((v) => {
          const destino = `/material/${v.id}`;
          return (
            <Link
              key={v.id}
              to={destino}
              className={
                camino.startsWith(destino) ? 'pestaña-activa' : 'btn-plano'
              }
            >
              {v.etiqueta}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </>
  );
}
